import React, { Component } from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import numeral from 'numeral';


import BlankState from '../../../components/BlankState';
import Page from '../../../components/Page';

import DataTable from '../../../components/DataTable';
import { TabHolder, Tab } from '../../../components/Tabs';
import Modal from '../../../components/Modal';

import InsurerForm from './InsurerForm';

import { listInsurers, listInsurerPremiums } from '../../../actions/insurers';

class Insurers extends Component{

	constructor(props){
		super(props);
		this.state = {
            insurers_loading: true,
            insurers: [],
            insurers_premiums: [],
            active_insurer: {}
        };
    }
    
    editInsurer(insurer){
        this.setState({ active_insurer: insurer });
    }

    componentDidMount() {
        this.props.listInsurers()
            .then((response)=>{
                this.setState({
                    insurers_loading: false
                });
            });
        
        this.props.listInsurerPremiums()
            .then((response)=>{
                this.setState({
                    insurers_loading: false
                });
        });
    }

	render(){
        
        
       
		const menuItems = [
			{ id: "all-insurers", name: "All Insurers", active: true },
            { id: "insurer-premiums", name: "Insurers by Premiums" },
            { id: "add-insurer", name: "Add Insurer" }   
        ]
        
        let { active_insurer, insurers_loading } = this.state;
        let { insurers } = this.props;

		return(
			<Page isAdminPage={ true } pageTitle="Insurers">
				<div className="clearfix">
					<TabHolder menuItems={ menuItems }>
						
						<Tab menuId={ menuItems[0].id } isActive={ true }>
                        {
                            insurers.insurers.length > 0 ?
                                <DataTable 
                                    tableId="insurers-table"
                                    columnTitles={ ["Company Logo", "Company Name", "Company TIN", "Postal Address", "Company Code", "Phone", "Email", "Policy Document","Actions"] }>
                                {
                                    insurers.insurers.map((insurer, index)=>{

                                        return(
                                            <tr key={ index } >
                                                <td>
                                                    <img 
                                                        src={ insurer.company_logo } 
                                                        className="img-rounded" 
                                                        alt= {insurer.company_name} />
                                                </td>
                                                <td>{ insurer.company_name }</td>
                                                <td>{ insurer.company_tin }</td>
                                                <td>{ insurer.postal_address }</td>
                                                <td>{ insurer.company_code }</td>
                                                <td>{ insurer.phone }</td>
                                                <td>{ insurer.email }</td>
                                                <td>
                                                    <a 
                                                        href={ insurer.policy_document } 
                                                        target="_blank" rel="noopener noreferrer"
                                                        className="btn btn-success btn-sm">
                                                        View
                                                    </a>
                                                </td>
                                                <td>
                                                    <button
                                                        data-toggle="modal" 
                                                        data-target=".edit-insurer-modal"
                                                        className="btn btn-warning btn-sm"
                                                        onClick={ ()=>{ this.editInsurer(insurer) } }>
                                                        Edit
                                                    </button>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                                </DataTable>
                            :
                                <BlankState 
                                    data={ insurers.insurers } 
                                    dataName="Insurers" 
                                    isDataLoading={ insurers_loading } />

                            }
                            <Modal 
                                title="Edit Insurer"
                                className="edit-insurer-modal"
                                closable={ true }>
                                
                                <InsurerForm edit={ true } insurer={ active_insurer } />
                            </Modal>
						</Tab>

                        <Tab menuId={ menuItems[1].id }>
                        {
                            insurers.insurers_by_premiums.length > 0 ?
                            <DataTable 
                                tableId="insurers-premiums-table"
                                columnTitles={ ["Company Name", "Company Code", "Policy Count", "Total Premiums (TSH)"] }>
                            
                            {
                                insurers.insurers_by_premiums.map((insurer, index)=>{
                                    return(
                                        <tr key={ index } >
                                            
                                            <td>{ insurer.company_name }</td>
                                            <td>{ insurer.company_code }</td>
                                            <td>{ insurer.policy_count }</td>
                                            <td>{ numeral(insurer.total_premiums).format('0,0.00') }</td>
                                        </tr>
                                    )
                                })
                            }
                            </DataTable>
                        :
                            <BlankState 
                                data={ insurers.insurers_by_premiums } 
                                dataName="Insurers by Premiums" 
                                isDataLoading={ insurers_loading } />

                        }
                    </Tab>
                       
                        <Tab menuId={ menuItems[2].id }>
                            <div className="col-md-6">
                                <InsurerForm />
                            </div>
						</Tab>
                        <Tab menuId={ menuItems[1].id }>
                            <DataTable 
                                tableId="update-insurers"
                                columnTitles={ ["Name", "Email", "Phone Number", "Join date", "Actions"] }>
                            
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </DataTable>
						</Tab>
					</TabHolder>
				</div>
			</Page>
		);
	}
}
const mapStateToProps = (state, ownProps) => ({
    user: state.user,
    insurers: state.insurers
});
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ listInsurers, listInsurerPremiums }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(Insurers);



// WEBPACK FOOTER //
// ./src/pages/dashboard/insurers/Insurers.jsx